import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { AuctionSvg } from './AuctionSvg'

export const EaAuctionIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={AuctionSvg} {...props} />
)
